export default {
      id: "fuel-filling-usage",
      viewBox: "0 0 26 28",
      url: __webpack_public_path__ + "img/icons.svg#fuel-filling",
      toString: function () {
        return this.url;
      }
    }